"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var radium_1 = require("radium");
var context_1 = require("../../../context");
var TableHeaderCell = /** @class */ (function (_super) {
    __extends(TableHeaderCell, _super);
    function TableHeaderCell() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableHeaderCell.prototype.render = function () {
        var _a = this.props, children = _a.children, rest = __rest(_a, ["children"]);
        return (React.createElement(context_1.THEME_CONTEXT.Consumer, null, function (theme) {
            var compiledStyles = styles(theme);
            return (React.createElement("th", __assign({}, rest, { style: compiledStyles }), children));
        }));
    };
    TableHeaderCell = __decorate([
        radium_1.default
    ], TableHeaderCell);
    return TableHeaderCell;
}(React.Component));
exports.TableHeaderCell = TableHeaderCell;
var styles = function (theme) { return ({
    border: theme.table.headerCell.border,
    padding: theme.table.headerCell.padding,
    background: theme.table.headerCell.background,
    fontSize: theme.table.headerCell.fontSize,
    fontWeight: 'bold',
    color: theme.table.headerCell.color,
}); };
